import { IDiscoveryEndPoints } from "../data_manager/data_manager_factory";
import { IClusterConfig } from "./iphoto_data_manager";

export class PhotoClusterHelper{
    pages: any = [];
    totalClusterCount: number = 0;
    clusterPadding: number = 0;
    clusterPageNumber: any = {};
    clusterConfig: IClusterConfig = {
        minAssetPerCluster :10,
        clustersPerPage: 10,
        viewMoreCount: 100,
        sortCriteria: 'createDate',
        limit: 10,
        skip: 0,
        timezoneOffset: 0 //TODO check this
    }
    
    constructor(){
    }
    
    setupPagesData(entityMap: { [key: string]: { assetCount: string }}, flag: any) {
        this.pages = [];
        this.totalClusterCount = 0;
        let clusters:any = [];
        let skip = 0;
        let lastClusterKey : string;
        let size = Object.keys(entityMap).length - 1; //replace this
        let i = 0;
        let pageNo = 0;
        let clustersOnPage = 0;
        let map = new Map();
        let projection = "&projection=createDate,dateTaken,assetType,files,faces,ownerAccountId,parentCollectionReferences,userTags,subType"
        Object.entries(entityMap).forEach(entry => {
            map.set(entry[0], entry[1]);
        });
        map.forEach((value: { assetCount: string }, key: string) => {
            let date = key;
            let val = value;
            date = date.replace(/'/g,"");
            let totalAssets = parseInt(val.assetCount, 10);
            let collapsedAssets = Math.min(totalAssets, this.clusterConfig.minAssetPerCluster);
            let expanededAssets = Math.max(totalAssets - this.clusterConfig.minAssetPerCluster, 0);
            this.totalClusterCount++;
            clustersOnPage++;
            clusters.push({
                date: date,
                collapsedAssets: collapsedAssets,
                expanededAssets: expanededAssets,
                totalAssets: totalAssets,
                pageNo: pageNo
            });
            this.clusterPageNumber[date] = pageNo;
            if (clustersOnPage >= this.clusterConfig.clustersPerPage || i >= size) {
                let prevUrl = "";
                let nextUrl = "";
                let currentUrl = "";
                let prevSkip = (this.totalClusterCount - clustersOnPage - this.clusterConfig.clustersPerPage);
                let nextSkip = this.totalClusterCount;
                let havePrevUrl = (prevSkip >= 0) ? true : false;
                let haveNextUrl = (clustersOnPage >= this.clusterConfig.clustersPerPage) ? true : false;
                if(flag){
                    let realtiveUrl = `&climit=${this.clusterConfig.clustersPerPage}&limit=${this.clusterConfig.minAssetPerCluster}&timeZoneOffset=${this.clusterConfig.timezoneOffset}&sortCriteria=${this.clusterConfig.sortCriteria}`
                    if(havePrevUrl){
                        prevUrl = `cskip=${prevSkip}${realtiveUrl}`;
                    }
                    if(haveNextUrl){
                        nextUrl = `cskip=${nextSkip}${realtiveUrl}`;
                    }
                    currentUrl = `cskip=${skip}${realtiveUrl}`;
                }else{
                    let realtiveUrl = `&limit=${this.clusterConfig.clustersPerPage}&minAsset=${this.clusterConfig.minAssetPerCluster}&sortCriteria=${this.clusterConfig.sortCriteria}&timezoneOffset=${this.clusterConfig.timezoneOffset}${projection}`
                    if(havePrevUrl){
                        prevUrl = `skip=${prevSkip}${realtiveUrl}`;
                    }
                    if(haveNextUrl){
                        nextUrl = `skip=${nextSkip}${realtiveUrl}`;
                    }
                    currentUrl = `skip=${skip}${realtiveUrl}`;
                }
                this.pages.push({
                    clusters: clusters,
                    after : lastClusterKey || "",
                    prevUrl : prevUrl,
                    currentUrl: currentUrl,
                    nextUrl: nextUrl
                });
                skip += clustersOnPage;
                clustersOnPage = 0;
                clusters = [];
                pageNo++;
                lastClusterKey = date;
            }
            i++;
        });
        return this.pages;
    }
}